import { TReduxActions } from '../../types/redux';
import { ILocation } from '../../store/pik_data/location';
import { ELocationsActionTypes } from '../../actions/locations';

export function locationsReducer(state: ILocation[] = [], action: TReduxActions) {
  if (action.type === ELocationsActionTypes.InitLocations) {
    return [...action.payload];
  }

  return state;
}
